import { Controller } from "@hotwired/stimulus"

// Actualiza un campo oculto (valores on/off) y envía el formulario padre al cambiar el switch.
export default class extends Controller {
  static targets = ["value", "track", "knob", "checkbox"]
  static values = {
    on: String,
    off: String
  }

  submitOnChange() {
    const checked = this.checkboxTarget.checked
    this.valueTarget.value = checked ? this.onValue : this.offValue
    this.reflectVisualState(checked)
    const form = this.element.closest("form")
    if (form) form.requestSubmit()
  }

  reflectVisualState(checked) {
    if (this.hasTrackTarget) {
      this.trackTarget.classList.toggle("bg-success", checked)
      this.trackTarget.classList.toggle("bg-primary-light-color/40", !checked)
    }
    if (this.hasKnobTarget) {
      this.knobTarget.classList.toggle("translate-x-5", checked)
      this.knobTarget.classList.toggle("translate-x-0", !checked)
    }
  }
}
